// @ts-strict-ignore
import { captureException } from '@sentry/nextjs';
import { Dispatch } from 'redux';
import { setAlert } from 'src/components/alert/actions';
import actionTypes from 'src/modules/user/shared/actionTypes';
import { ReduxState } from 'src/store/store';
import { get, getServerSideConfig, put } from 'src/utils/api';

export const fetchProfile = () => {
  return async (dispatch: Dispatch, getState: () => ReduxState) => {
    dispatch({ type: actionTypes.FETCH_PROFILE });
    try {
      const { currentUser, sessionId } = getState().context;
      const response = await get(`private/users/${currentUser.userId}/profile`, getServerSideConfig(sessionId));
      dispatch({
        type: actionTypes.FETCH_PROFILE_SUCCESS,
        data: response.data,
      });
    } catch (ex) {
      captureException(ex);
      dispatch(setAlert());
    }
  };
};

export const updateBasics = (basicData: {
  aboutMe?: string | null;
  gender?: string | null;
  genderSelfDescription?: string | null;
  isGenderPrivate?: boolean;
  dateOfBirth?: string | null;
  isDateOfBirthPrivate?: boolean;
  location?: {
    countryCode?: string | null;
    regionCode?: string | null;
  };
  isCountryPrivate?: boolean;
  isRegionPrivate?: boolean;
  ethnicity?: string | null;
  isEthnicityPrivate?: boolean;
  isConditionsEnabled?: boolean;
  isInterestsEnabled?: boolean;
}) => {
  return async (dispatch, getState: () => ReduxState) => {
    try {
      const userId = getState().context.currentUser.userId;
      const { data } = await put(`private/users/${userId}/profile/basics`, { basicData });
      dispatch({
        type: actionTypes.UPDATE_PROFILE_BASICS_SUCCESS,
        data,
      });
    } catch (ex) {
      captureException(ex);
      dispatch(setAlert());
    }
  };
};
